




















































import Vue from "vue";
import { Messages } from "@/constants/messages";
export default Vue.extend({
  name: "VideoLinks",
  data(): {
    actualVideo: string;
    videoLinks: string[];
    errorMessage: string;
    invalidVideo: boolean;
    mess: any;
  } {
    return {
      actualVideo: "",
      videoLinks: [],
      errorMessage: "",
      invalidVideo: false,
      mess: Messages,
    };
  },
  methods: {
    addVideo() {
      if (this.videoLinks.length === 2) {
        this.errorMessage = this.mess.error_allowed__max + "2";
        this.invalidVideo = true;
        return;
      }
      if (this.actualVideo !== "" && this.checkVideo(this.actualVideo)) {
        this.videoLinks.push(this.actualVideo);
        this.actualVideo = "";
        this.invalidVideo = false;
        this.errorMessage = "";
        this.$emit("videoLinks", this.videoLinks);
      } else {
        this.actualVideo = "";
        this.errorMessage = this.mess.regApp_videos__error;
        this.invalidVideo = true;
      }
    },
    removeLink(index: number) {
      this.videoLinks.splice(index, 1);
      this.invalidVideo = false;
    },
    checkVideo(video: string): boolean {
      return (
        video.startsWith("https://www.youtube.com/watch?v=") ||
        video.startsWith("https://youtu.be/")
      );
    },
  },
});
